import React, {useState, useEffect} from "react";
import Button from "../Components/Buttons";
import {CustomInput} from "./CustomFormElements";

export const CatalogTaxonomy = ({
                                  taxonomyCatalog, canEdit, onChange, onSaveTaxonomy
                                }) => {
  const [localTaxonomy, setLocalTaxonomy] = useState(taxonomyCatalog || {attributes: [], categories: []});

  const [newAttrName, setNewAttrName] = useState("");
  const [newAttrValues, setNewAttrValues] = useState("");

  const [newCategoryParent, setNewCategoryParent] = useState("");
  const [newCategoryChildren, setNewCategoryChildren] = useState("");

  const [newAttributeValueByIndex, setNewAttributeValueByIndex] = useState({});
  const [newCategoryChildByIndex, setNewCategoryChildByIndex] = useState({});

  useEffect(() => {
    if (taxonomyCatalog) {
      setLocalTaxonomy(taxonomyCatalog);
    }
  }, [taxonomyCatalog]);

  if (!localTaxonomy) {
    return (<div className="mt-2">
      <small className="text-muted">No taxonomy data</small>
    </div>);
  }

  const safeAttributes = localTaxonomy.attributes || [];
  const safeCategories = localTaxonomy.categories || [];

  const emitChange = (updated) => {
    setLocalTaxonomy(updated);
    onChange && onChange(updated);
  };


  const handleAttributeNameChange = (index, value) => {
    const updated = {...localTaxonomy};
    updated.attributes = [...safeAttributes];
    updated.attributes[index] = {
      ...updated.attributes[index], name: value,
    };
    emitChange(updated);
  };

  const handleAddAttributeValue = (index) => {
    const raw = newAttributeValueByIndex[index] || "";
       const trimmed = raw.trim();
    if (!trimmed) return;

    const updated = {...localTaxonomy};
    updated.attributes = [...safeAttributes];

    const currentAttr = updated.attributes[index] || {};
    const currentValues = currentAttr.values || [];

    if (!currentValues.includes(trimmed)) {
      updated.attributes[index] = {
        ...currentAttr, values: [...currentValues, trimmed],
      };
      emitChange(updated);
    }

    setNewAttributeValueByIndex((prev) => ({
      ...prev, [index]: "",
    }));
  };

  const handleAttributeValueInputChange = (index, _id, value) => {
    setNewAttributeValueByIndex((prev) => ({
      ...prev, [index]: value,
    }));
  };

  const handleRemoveAttributeValue = (attrIndex, valueToRemove) => {
    const updated = {...localTaxonomy};
    updated.attributes = [...safeAttributes];

    const currentAttr = updated.attributes[attrIndex] || {};
    const currentValues = currentAttr.values || [];

    updated.attributes[attrIndex] = {
      ...currentAttr, values: currentValues.filter((v) => v !== valueToRemove),
    };

    emitChange(updated);
  };

  // NEW: remove whole attribute by index
  const handleRemoveAttribute = (index) => {
    const updated = {...localTaxonomy};
    updated.attributes = safeAttributes.filter((_, i) => i !== index);
    emitChange(updated);
  };

  const handleAddNewAttribute = () => {
    const name = newAttrName.trim();
    if (!name) return;

    const values = newAttrValues
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v.length > 0) || [];

    const updated = {...localTaxonomy};
    updated.attributes = [...safeAttributes, {name, values}];

    emitChange(updated);
    setNewAttrName("");
    setNewAttrValues("");
  };

  const handleNewAttrNameChange = (_id, value) => {
    setNewAttrName(value);
  };

  const handleNewAttrValuesChange = (_id, value) => {
    setNewAttrValues(value);
  };


  const handleCategoryParentChange = (index, value) => {
    const updated = {...localTaxonomy};
    updated.categories = [...safeCategories];
    updated.categories[index] = {
      ...updated.categories[index], parent: value,
    };
    emitChange(updated);
  };

  const handleAddCategoryChild = (index) => {
    const raw = newCategoryChildByIndex[index] || "";
    const trimmed = raw.trim();
    if (!trimmed) return;

    const updated = {...localTaxonomy};
    updated.categories = [...safeCategories];

    const currentCat = updated.categories[index] || {};
    const currentChildren = currentCat.children || [];

    if (!currentChildren.includes(trimmed)) {
      updated.categories[index] = {
        ...currentCat, children: [...currentChildren, trimmed],
      };
      emitChange(updated);
    }

    setNewCategoryChildByIndex((prev) => ({
      ...prev, [index]: "",
    }));
  };

  const handleCategoryChildInputChange = (index, _id, value) => {
    setNewCategoryChildByIndex((prev) => ({
      ...prev, [index]: value,
    }));
  };

  const handleRemoveCategoryChild = (catIndex, childToRemove) => {
    const updated = {...localTaxonomy};
    updated.categories = [...safeCategories];

    const currentCat = updated.categories[catIndex] || {};
    const currentChildren = currentCat.children || [];

    updated.categories[catIndex] = {
      ...currentCat, children: currentChildren.filter((c) => c !== childToRemove),
    };

    emitChange(updated);
  };

  // NEW: remove whole category by index
  const handleRemoveCategory = (index) => {
    const updated = {...localTaxonomy};
    updated.categories = safeCategories.filter((_, i) => i !== index);
    emitChange(updated);
  };

  const handleAddNewCategory = () => {
    const parent = newCategoryParent.trim();
    if (!parent) return;

    const children = newCategoryChildren
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v.length > 0) || [];

    const updated = {...localTaxonomy};
    updated.categories = [...safeCategories, {parent, children}];

    emitChange(updated);
    setNewCategoryParent("");
    setNewCategoryChildren("");
  };

  const handleNewCategoryParentChange = (_id, value) => {
    setNewCategoryParent(value);
  };

  const handleNewCategoryChildrenChange = (_id, value) => {
    setNewCategoryChildren(value);
  };

  return (<>
    <div className="row mt-4">
      <div className="col-12 radius-yes p-3 bg-yes">
        <div className="row">
          <div className="col-12 col-lg-7 mb-4">
            <h3 className="mb-2">Attributes</h3>

            {safeAttributes.map((attr, index) => (<div
              key={index}
              className="int-col-2 p-2 border-yes radius-yes mb-4"
            >
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Attribute name</div>
                  <div className="small-font">
                    Original attribute name from the catalog
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <div className="align-wrapper flex-grow-1">
                    <CustomInput
                      id={`taxonomy-attribute-name-${index}`}
                      label=""
                      placeholder=""
                      value={attr.name || ""}
                      disabled={!canEdit}
                      onChange={(_id, value) => handleAttributeNameChange(index, value)}
                    />
                  </div>
                </div>
              </div>

              <div className="input-block d-flex flex-row justify-between mt-3">
                <div className="input-description">
                  <div className="input-title">Values</div>
                  <div className="small-font">
                    Attribute values displayed as tags
                  </div>
                </div>

                <div
                  className="align-wrapper d-flex align-center"
                >
                  <div style={{width: "100%"}}>
                    <div
                      className="d-flex mb-2"
                      style={{
                        display: "flex", flexWrap: "wrap", gap: "8px", width: "100%", justifyContent: "flex-start",
                      }}
                    >
                      {(attr.values || []).map((val) => {
                        const strVal = String(val || "");
                        const words = strVal.split(/\s+/);
                        const displayVal =
                          words.length > 10
                            ? words.slice(0, 10).join(" ") + "…"
                            : strVal;

                        return (
                          <span
                            key={val}
                            className="selected-tag"
                            title={strVal}
                            style={{
                              pointerEvents: "auto",
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              flexShrink: 0,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {displayVal}
                            {canEdit && (
                              <button
                                type="button"
                                className="remove-tag"
                                style={{pointerEvents: "auto"}}
                                onClick={() => handleRemoveAttributeValue(index, val)}
                              >
                                <i className="fa-solid fa-xmark"/>
                              </button>
                            )}
                          </span>
                        );
                      })}

                      {(!attr.values || attr.values.length === 0) && (
                        <span className="placeholder small-font">No values</span>)}
                    </div>

                    {canEdit && (<div
                      className="d-flex flex-row gap-2 align-center"
                      style={{marginTop: 4}}
                    >
                      <div className="align-wrapper d-flex align-center flex-grow-1">
                        <CustomInput
                          id={`taxonomy-attribute-add-value-${index}`}
                          label=""
                          placeholder="Add new value"
                          value={newAttributeValueByIndex[index] || ""}
                          disabled={!canEdit}
                          onChange={(id, value) => handleAttributeValueInputChange(index, id, value)}
                        />
                      </div>
                      <Button
                        variant="secondary"
                        size="small"
                        disabled={!canEdit}
                        onClick={() => handleAddAttributeValue(index)}
                        style={{whiteSpace: "nowrap"}}
                      >
                        Add value
                      </Button>
                    </div>)}
                  </div>
                </div>

              </div>
              {canEdit && (
                <div className="d-flex justify-end mt-2">
                  <Button
                    variant="danger"
                    size="small"
                    onClick={() => handleRemoveAttribute(index)}
                    style={{whiteSpace: "nowrap"}}
                  >
                    Delete
                  </Button>
                </div>
              )}
            </div>))}

            {canEdit && (<div
              className="input-row input-block d-flex flex-column gap-2 mt-4"
              style={{
                padding: "18px 20px 20px",
                borderRadius: 14,
                border: "1px solid rgba(0,0,0,0.5)",
                background: "linear-gradient(135deg, rgba(0,0,0,0.02), rgba(0,0,0,0))",
                boxShadow: "0 0 0 1px rgba(0,0,0,0.10), 0 14px 30px rgba(0,0,0,0.20), 0 26px 60px rgba(0,0,0,0.12)",
              }}
            >
              <div
                style={{
                  fontSize: 13, letterSpacing: 0.5, textTransform: "uppercase", opacity: 0.8, marginBottom: 6,
                }}
              >
                New attribute
              </div>

              <div className="d-flex flex-column flex-md-row justify-between gap-3">
                <div className="input-description">
                  <div className="input-title">Attribute name</div>
                  <div className="small-font">
                    Specify name for a new attribute
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="taxonomy-new-attribute-name"
                    label=""
                    placeholder="Attribute name"
                    value={newAttrName}
                    disabled={!canEdit}
                    onChange={handleNewAttrNameChange}
                  />
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row justify-between gap-3 mt-2">
                <div className="input-description">
                  <div className="input-title">Values (optional)</div>
                  <div className="small-font">
                    Example: apple, samsung, msi
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="taxonomy-new-attribute-values"
                    label=""
                    placeholder="value1, value2, value3"
                    value={newAttrValues}
                    disabled={!canEdit}
                    onChange={handleNewAttrValuesChange}
                  />
                </div>
              </div>

              <div className="d-flex justify-end mt-2">
                <Button
                  variant="primary"
                  size="small"
                  disabled={!canEdit}
                  onClick={handleAddNewAttribute}
                  style={{whiteSpace: "nowrap"}}
                >
                  Add attribute
                </Button>
              </div>
            </div>)}
          </div>

          <div className="col-12 col-lg-5">
            <h3 className="mb-2">Categories</h3>

            {safeCategories.map((cat, index) => (<div
              key={index}
              className="d-flex flex-column gap-2 mb-3 border rounded p-3"
            >
              <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                  <div className="input-title">Parent category</div>
                  <div className="small-font">
                    Main category (for example, Electronics)
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <div className="align-wrapper d-flex align-center" style={{gap: 8}}>
                    <CustomInput
                      id={`taxonomy-category-parent-${index}`}
                      label=""
                      placeholder=""
                      value={cat.parent || ""}
                      disabled={!canEdit}
                      onChange={(_id, value) => handleCategoryParentChange(index, value)}
                    />
                  </div>
                </div>
              </div>

              <div className="input-block d-flex flex-row justify-between mt-2">
                <div className="input-description">
                  <div className="input-title">Children</div>
                  <div className="small-font">
                    Subcategories displayed as tags
                  </div>
                </div>

                <div
                  className="align-wrapper d-flex flex-column"
                >
                  <div
                    className="d-flex mb-2"
                    style={{
                      display: "flex", flexWrap: "wrap", gap: "8px", width: "100%",
                    }}
                  >
                    {(cat.children || []).map((child) => (<span
                      key={child}
                      className="selected-tag"
                      style={{
                        pointerEvents: "auto",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                            {child}
                      {canEdit && (<button
                        type="button"
                        className="remove-tag"
                        style={{pointerEvents: "auto"}}
                        onClick={() => handleRemoveCategoryChild(index, child)}
                      >
                        <i className="fa-solid fa-xmark"/>
                      </button>)}
                          </span>))}

                    {(!cat.children || cat.children.length === 0) && (<span className="placeholder small-font">
                            No subcategories
                          </span>)}
                  </div>

                  {canEdit && (<div
                    className="d-flex flex-row gap-2 align-center"
                    style={{marginTop: 4}}
                  >
                    <div className="align-wrapper d-flex align-center flex-grow-1">
                      <CustomInput
                        id={`taxonomy-category-add-child-${index}`}
                        label=""
                        placeholder="Add new child"
                        value={newCategoryChildByIndex[index] || ""}
                        disabled={!canEdit}
                        onChange={(id, value) => handleCategoryChildInputChange(index, id, value)}
                      />
                    </div>
                    <Button
                      variant="secondary"
                      size="small"
                      disabled={!canEdit}
                      onClick={() => handleAddCategoryChild(index)}
                      style={{whiteSpace: "nowrap"}}
                    >
                      Add child
                    </Button>
                  </div>)}
                </div>

              </div>
              {canEdit && (
                <div className="d-flex justify-end mt-2">
                  <Button
                    variant="danger"
                    size="small"
                    onClick={() => handleRemoveCategory(index)}
                    style={{whiteSpace: "nowrap"}}
                  >
                    Delete
                  </Button>
                </div>
              )}
            </div>))}

            {canEdit && (<div
              className="input-row input-block d-flex flex-column gap-2 mt-4"
              style={{
                padding: "18px 20px 20px",
                borderRadius: 14,
                border: "1px solid rgba(0,0,0,0.5)",
                background: "linear-gradient(135deg, rgba(0,0,0,0.02), rgba(0,0,0,0))",
                boxShadow: "0 0 0 1px rgba(0,0,0,0.10), 0 14px 30px rgba(0,0,0,0.20), 0 26px 60px rgba(0,0,0,0.12)",
              }}
            >
              <div
                style={{
                  fontSize: 13, letterSpacing: 0.5, textTransform: "uppercase", opacity: 0.8, marginBottom: 6,
                }}
              >
                New category
              </div>

              <div className="d-flex flex-column flex-md-row justify-between gap-3">
                <div className="input-description">
                  <div className="input-title">Parent category</div>
                  <div className="small-font">
                    Specify main category for this group
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="taxonomy-new-category-parent"
                    label=""
                    placeholder="Parent category"
                    value={newCategoryParent}
                    disabled={!canEdit}
                    onChange={handleNewCategoryParentChange}
                  />
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row justify-between gap-3 mt-2">
                <div className="input-description">
                  <div className="input-title">Children (optional)</div>
                  <div className="small-font">
                    Example: Audio Equipment, Computers, Monitors
                  </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                  <CustomInput
                    id="taxonomy-new-category-children"
                    label=""
                    placeholder="child1, child2, child3"
                    value={newCategoryChildren}
                    disabled={!canEdit}
                    onChange={handleNewCategoryChildrenChange}
                  />
                </div>
              </div>

              <div className="d-flex justify-end mt-2">
                <Button
                  variant="primary"
                  size="small"
                  disabled={!canEdit}
                  onClick={handleAddNewCategory}
                  style={{whiteSpace: "nowrap"}}
                >
                  Add category
                </Button>
              </div>
            </div>)}
          </div>
        </div>
      </div>
    </div>

    <div className="buttons-container justify-end gap-12">
      <Button variant="primary" size="medium" disabled={!canEdit} onClick={onSaveTaxonomy}>
        Save taxonomy
      </Button>
    </div>
  </>);
};
